export default __webpack_public_path__ + "static/media/whoWillSeeResults_lg_woman.db1a81bc.png";